import { render, staticRenderFns } from "./questionRequisitionList.vue?vue&type=template&id=0d341a33&scoped=true&"
import script from "./questionRequisitionList.vue?vue&type=script&lang=js&"
export * from "./questionRequisitionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d341a33",
  null
  
)

export default component.exports